/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var UriConstants = /** @class */ (function () {
    function UriConstants() {
    }
    UriConstants.d365NoCacheParameter = "d365mkt-nocache";
    UriConstants.readableEventId = "readableEventId";
    UriConstants.eventRegistrationId = "eventRegistrationId";
    UriConstants.prefillAliasTrackingParameter = "msdynmkt_prefill";
    UriConstants.prefillAliasId = "prefillAliasId";
    return UriConstants;
}());
export { UriConstants };
